// import React from "react";
// import "./PlantationOneTestimonial.scss";
// import Testimonials from "../../../../default-components/Testimonials";
// import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
// import { useCollection } from "../../../../firebase-files/hooks/useCollection";

// const PlantationOneTestimonial = () => {
//   const { user } = useAuthContext();
//   const isAdmin = user && user.role === "admin";

//   const { documents: testimonials } = useCollection("media", [
//     "category",
//     "==",
//     "testimonial",
//   ]);

//   // Check if there are any active testimonials
//   const hasActiveTestimonials =
//     testimonials &&
//     testimonials.some((testimonial) => testimonial.status === "active");

//   // Only render if admin or there are active testimonials
//   if (!isAdmin && !hasActiveTestimonials) {
//     return null;
//   }

//   return (
//     <section className="nature-testimonials">
//       <div className="nature-container">
//         <div className="testimonial-header">
//           <p className="nature-subheading">
//             <span>CLIENT TESTIMONIALS</span>
//             <div className="nature-subheading__underline nature-subheading__underline--left"></div>
//           </p>
//           <h2 className="nature-heading">What our clients say</h2>
//         </div>
//         <Testimonials
//           category="testimonial"
//           pageName="home"
//           section="testimonial"
//           addMoreVideosButton={false}
//           addMoreTextContentButton={false}
//         />
//       </div>
//     </section>
//   );
// };

// export default PlantationOneTestimonial;








import React, { useEffect, useState } from "react";
import "./PlantationOneTestimonial.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useFirestore } from "../../../../firebase-files/hooks/useFirestore";
import AddTestimonials from "../../../../default-hooks/addTestimonials";
import UpdateTestimonial from "../../../../default-hooks/UpdateTestimonial";
import firebase from "firebase/app";
import "firebase/storage";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const PlantationOneTestimonial = () => {
  const { user } = useAuthContext();
  const { documents: testimonials, error: testimonialsError } = useCollection("testimonials");
  const { documents: allUsers, error: usersError } = useCollection("users");
  const { deleteDocument } = useFirestore("testimonials");

  const [current, setCurrent] = useState(0);
  const [editingTestimonial, setEditingTestimonial] = useState(null);
  const [userMap, setUserMap] = useState({});
  const [deletePopup, setDeletePopup] = useState(false);
  const [toDeleteId, setToDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const isAdmin = user?.role === "admin";

  useEffect(() => {
    if (allUsers && allUsers.length > 0) {
      const map = {};
      allUsers.forEach((u) => {
        map[u.id] = u;
      });
      setUserMap(map);
    }
  }, [allUsers]);

  const activeTestimonials = Array.isArray(testimonials)
    ? testimonials.filter((t) => (isAdmin ? true : t.status === "active"))
    : [];

  useEffect(() => {
    if (activeTestimonials.length === 0 || current >= activeTestimonials.length) {
      setCurrent(0);
    }
  }, [activeTestimonials, current]);

  useEffect(() => {
    if (activeTestimonials.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % activeTestimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeTestimonials]);

  const handleDeleteConfirm = async () => {
    if (!toDeleteId) return;
    setDeleting(true);
    try {
      const folderPath = `testimonialImages/${toDeleteId}`;
      const storageRef = firebase.storage().ref(folderPath);
      const listResult = await storageRef.listAll();

      if (listResult.items.length > 0) {
        const deletePromises = listResult.items.map((itemRef) => itemRef.delete());
        await Promise.all(deletePromises);
      }

      await deleteDocument(toDeleteId);

      setDeletePopup(false);
      setToDeleteId(null);
      setCurrent(0);
    } catch (err) {
      console.error("Error deleting testimonial and storage files:", err);
      alert("Failed to delete testimonial and associated files. Check console.");
    }
    setDeleting(false);
  };

  const openDeletePopup = (id) => {
    setToDeleteId(id);
    setDeletePopup(true);
  };

  const closeDeletePopup = () => {
    setDeletePopup(false);
    setToDeleteId(null);
  };

  if (testimonialsError || usersError)
    return <div className="error-message">Error loading data</div>;

  if (!testimonials || !allUsers)
    return <div className="loading-message">Loading testimonials...</div>;

  if (activeTestimonials.length === 0)
    return (
      <section className="eco-testimonial-wrapper">
        <div className="eco-testimonial-text-side">
          <p>No active testimonials available yet.</p>
          {isAdmin && <AddTestimonials />}
        </div>
      </section>
    );

  const testimonial = activeTestimonials[current];
  if (!testimonial)
    return (
      <section className="eco-one-testimonial-wrapper">
        <div className="eco-testimonial-text-side">
          <p>No testimonials available to display.</p>
          {isAdmin && <AddTestimonials />}
        </div>
      </section>
    );

  const testimonialUser = userMap[testimonial.createdBy] || {};

  return (
    <section className="eco-testimonial-wrapper">
      <div className="eco-testimonial-image-side">
        <div className="img-main">
          <img
            src={testimonial.mainImg || "https://via.placeholder.com/400x300"}
            alt="Testimonial"
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }}
          />
        </div>

        <div className="img-overlay">
          <img
            src={testimonialUser.photoURL || testimonial.overlayImg || "https://via.placeholder.com/100"}
            alt={testimonial.name || "User"}
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 0, backgroundColor: "#eee" }}
          />
        </div>
      </div>

      <div className="eco-testimonial-text-side">
        <div className="testimonial-quote">
          <span className="quote-icon" aria-hidden="true">❝</span>
          <p>{testimonial.description}</p>

          <div className="stars" aria-label={`Rating: ${testimonial.rating || 0} out of 5`}>
            {"★".repeat(Math.round(testimonial.rating || 0))}
            {"☆".repeat(5 - Math.round(testimonial.rating || 0))}
          </div>

          <h5>{testimonial.name || "Anonymous"}</h5>

          {/* ✅ Show role below name */}
          {testimonial.role && (
            <p style={{ marginTop: "0.2rem", color: "gray", fontSize: "0.95rem" }}>
              {testimonial.role}
            </p>
          )}

          {isAdmin && (
            <div className="admin-actions" style={{ marginTop: "0.8rem" }}>
              <EditIcon
                className="edit-icon"
                onClick={() => setEditingTestimonial(testimonial)}
                style={{ cursor: "pointer", marginRight: "10px" }}
                title="Edit Testimonial"
                role="button"
                tabIndex={0}
              />
              <DeleteIcon
                className="delete-icon"
                onClick={() => openDeletePopup(testimonial.id)}
                style={{ cursor: "pointer" }}
                title="Delete Testimonial"
                role="button"
                tabIndex={0}
              />
            </div>
          )}
        </div>

        <div className="testimonial-dots" role="tablist" aria-label="Testimonial navigation dots">
          {activeTestimonials.map((_, i) => (
            <span
              key={i}
              className={i === current ? "dot active" : "dot"}
              onClick={() => setCurrent(i)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setCurrent(i);
                }
              }}
              aria-selected={i === current}
              role="tab"
              tabIndex={0}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>

        {isAdmin && <AddTestimonials />}

        {editingTestimonial && (
          <UpdateTestimonial
            testimonial={editingTestimonial}
            onClose={() => setEditingTestimonial(null)}
          />
        )}
      </div>

      {/* ✅ Delete Confirmation Popup with buttons swapped */}
      {deletePopup && (
        <div className="delete-confirm-overlay" role="dialog" aria-modal="true">
          <div className="delete-confirm-modal">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this testimonial?</p>
            <div style={{ marginTop: "1rem" }}>
              <button
                onClick={handleDeleteConfirm}
                disabled={deleting}
                style={{
                  backgroundColor: "#b00020",
                  color: "white",
                  marginRight: "1rem",
                }}
              >
                {deleting ? "Deleting..." : "Delete"}
              </button>
              <button onClick={closeDeletePopup}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PlantationOneTestimonial;
